import Countdown from "../containers/countdown";
import pure from "./higher-order/pure";
import React from "react";
import showRaceDate from "../show-race-date";

export default pure(function RaceCountdown({ race }) {
  return (
    <Countdown date={race.get("post_time")} name={race.get("track_name") + " race #" + race.get("race_number")} withDate={showRaceDate(race)} />
  );
});

